module.exports = __webpack_public_path__ + "images/emoji/necktie.f2019c2c20fee8d4dd6c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/necktie.png
// module id = MSEl
// module chunks = 1